import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import TextInput from "@/components/inputs/text.vue"
  import {PropType, ref} from "vue"
  import {Trademark} from "@/endpoints/rutsolve/gql/generated/graphql"
  import ErrorModal from "@/components/modals/error.vue"

  
export default /*@__PURE__*/_defineComponent({
  __name: 'trademark',
  props: /*@__PURE__*/_mergeModels({
    readOnly: {
      default: false,
      required: false,
      type: Boolean
    }
  }, {
    "value": {
    default: null,
    required: true,
    type: Object as PropType<Trademark>
  },
    "valueModifiers": {},
  }),
  emits: ["update:value"],
  setup(__props) {

  

  const value = _useModel(__props, "value")

  const error = ref<Error>(null)

return (_ctx: any,_cache: any) => {
  const _component_scoped = _resolveComponent("scoped")!

  return (value.value)
    ? (_openBlock(), _createBlock(_component_scoped, { key: 0 }, {
        default: _withCtx(() => [
          _createVNode(TextInput, {
            value: value.value.name,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((value.value.name) = $event)),
            title: "Name",
            readOnly: __props.readOnly
          }, null, 8, ["value", "readOnly"]),
          _createVNode(TextInput, {
            value: value.value.memorandum,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((value.value.memorandum) = $event)),
            title: "Memorandum",
            readOnly: __props.readOnly,
            multiline: ""
          }, null, 8, ["value", "readOnly"]),
          (error.value)
            ? (_openBlock(), _createBlock(ErrorModal, {
                key: 0,
                error: error.value,
                "onUpdate:error": _cache[2] || (_cache[2] = ($event: any) => ((error).value = $event))
              }, null, 8, ["error"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})